import activeMapPin from "../../assets/images/activeMapPin.svg.js";
import clusterMap from "../../assets/images/clusterMap.svg.js";
import hoverClusterMap from "../../assets/images/hoverClusterMap.svg.js";
import hoverMapPin from "../../assets/images/hoverMapPin.svg.js";
import mapPin from "../../assets/images/mapPin.svg.js";
const MAP_PLACEMARK = {
  default: mapPin,
  hover: hoverMapPin,
  active: activeMapPin
};
const MAP_CLUSTER = {
  default: clusterMap,
  hover: hoverClusterMap
};
const MAP_CENTER = {
  lat: 37.64,
  lng: 55.76
};
export {
  MAP_CENTER,
  MAP_CLUSTER,
  MAP_PLACEMARK
};
//# sourceMappingURL=Map.constants.js.map
